var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',_vm._g({directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],style:(_vm.computedStyles),domProps:{"value":(_vm.val)},on:{"focus":_vm.resize,"input":function($event){if($event.target.composing)return;_vm.val=$event.target.value}}},_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }